module.exports = __webpack_public_path__ + "static/media/Step3.7.f2cbc982.jpg";